/**
 * External Dependencies
 */
import { get, values } from 'lodash';

/**
 * Internal Dependencies
 */

export default (state) => values(get(state, 'notices.items', {})); 
